import { Specialist } from "~/types/specialist";
import { Option } from "~/types/component";
import { sex } from "~/const/options";
import { MasterState } from "~/redux/modules/master";

export const isPublicFormat = (val: Specialist["isPublic"]) => {
  if (val === true) {
    return "公開";
  } else {
    return "非公開";
  }
};

export const sexFormat = (val: Specialist["sex"]) => findLabel(val, sex);

export const businessFormat = (
  val: Specialist["business"],
  master: MasterState
) => {
  const { businesses } = master;
  return findLabel(val, businesses);
};

export const prefectureFormat = (
  val: Specialist["prefecture"],
  master: MasterState
) => {
  const { prefectures } = master;
  return findLabel(val, prefectures);
};

export const contactFormat = (
  val: Specialist["contactMethod1"],
  master: MasterState
) => {
  const { contacts } = master;
  return findLabel(val, contacts);
};

// optionsから特定のlabelを取得
const findLabel = (val: string | number | undefined, options: Option[]) => {
  const result = options.find((item) => item.value === val);
  if (result) {
    return result.label;
  } else {
    return "";
  }
};
